import { instance } from '../instance';

export const listElementsOfLevelForCC = (param, headers) => instance.post('auth/listElementsOfLevel', param, headers);
export const listUserAuthOfResForCC = (param, headers) => instance.post('auth/listUserAuthOfRes', param, headers);
export const listUserAuthResForCC = (param, headers) => instance.post('auth/listUserAuthRes', param, headers);
export const listMyAuthOfResForCC = (param, headers) => instance.post('auth/listMyAuthOfRes', param, headers);
export const listMyAuthResForCC = (param, headers) => instance.post('auth/listMyAuthRes', param, headers);
export const modifyUserAuthForCC = (param, headers) => instance.post('auth/modifyUserAuth', param, headers);
